import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils";
import type { PalmTouchPoints } from "../../types/palm";
import { getPalmAdjustmentMap } from "../../types/palmEnumString";

export const PalmTouchCodeSuccess = 999;

interface IProps {
  isGesture: boolean;
  needGesture: number;
  status: string;
  adjustment: number;
  touchPoints: PalmTouchPoints | null;
}

export const ScanBottom = (props: IProps) => {
  const { t } = useTranslation();
  const { isGesture, needGesture, adjustment, touchPoints } = props;

  let text = "";
  let isErrorColor = false;

  const PalmAdjustmentMap = getPalmAdjustmentMap();

  if (isGesture) {
    if (needGesture > 0) {
      text = t("scan.showGesture");
    }
  } else {
    if (touchPoints && touchPoints.code == PalmTouchCodeSuccess) {
      text = t("scan.perfect");
    } else if (touchPoints && touchPoints.code !== 4) {
      text = t("scan.bringDotsTogether");
    }
  }

  if (!text) {
    text = PalmAdjustmentMap[adjustment] || "";
    isErrorColor = adjustment === 0 || adjustment === 23 ? false : true;
  }

  if (!text.length) {
    isErrorColor = false;
  }

  return (
    <div className="bg-[#141517] flex-1 p-3 flex flex-col items-center justify-center gap-4">
      <div
        className={cn(
          "text-center justify-start text-[#FCFCFC] text-sm font-medium leading-tight px-4 py-3 rounded-4",
          isErrorColor ? "bg-error" : "bg-transparent"
        )}
      >
        {text}
      </div>
      {/* <img src="/img/icon/veros.svg" className="w-16 h-16" /> */}
    </div>
  );
};
